'use client';

import { CampaignSectionSubTitle, CampaignSectionTitle } from '../components/CampaignSectionHeader';
import ViewAllButton from '../components/ViewAllButton';

import HiddenGemProductList from './HiddenGemProductList';
import SectionHeader from '../components/SectionHeader';
import QueryBoundary from '../../utils/react/QueryBoundary';
import { ProductGrid, ProductGridSkeleton } from '../components/ProductGrid';
import SectionContainer from '../components/SectionContainer';

export const HiddenGemSection = () => {
  const handleViewAll = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/campaign/ggu-hidden-gem/';
    }
  };

  return (
    <SectionContainer
      containerInnerClassName="items-center gap-12"
      containerInnerStyle={{ transform: 'scale(1.0001)', backgroundColor: 'white' }}
    >
      <div className="hidden desktop:flex w-full flex-col items-end m-0 justify-start gap-3">
        <CampaignSectionTitle theme="light">Our Hidden Gems</CampaignSectionTitle>
        <CampaignSectionSubTitle theme="light">Handpicked From Our Glow Vault</CampaignSectionSubTitle>
      </div>
      <SectionHeader
        theme="light"
        title="Our Hidden Gems"
        subtitle="Handpicked From Our Glow Vault"
        className="flex desktop:hidden"
        href={handleViewAll}
      />
      <QueryBoundary clientOnly loadingFallback={<ProductGridSkeleton length={5} />}>
        <ProductGrid>
          <HiddenGemProductList />
        </ProductGrid>
      </QueryBoundary>

      <ViewAllButton onClick={handleViewAll} theme="light" />
    </SectionContainer>
  );
};
